import React, { Fragment, useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Button, Card, CardBody, Col, Form, FormGroup, Input, Label, Row, Table, Modal, ModalHeader, ModalFooter, Toast, ToastBody
  , Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import { GetCookieToken } from "../../Cookie/GetCookie";
import { FetchAxiosGet } from "../../../api/axios";
import LoadingPage from "../../TESTPage/LoadingPage";
import Select from 'react-select';
import axios from "axios";
import MyDatePicker from "../../../components/Common/MyDateTimePicker";
import { ConvertDate } from "../../Function/ConvertDate";
import PersonalTimeEntryExitGroup from "./EntryExitUser";
import { useNavigate } from "react-router-dom";
import { CheckPosition } from "../../Function/CheckPosition";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";
import NewThaiDatePicker from "../../../components/Common/NewThaiDatePicker";

const API_URL = process.env.REACT_APP_API_CORS;

function TimeEntryExitGroup(props) {
  const {userInfo} = props
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [orgOptions, setOrgOptions] = useState([]);
  const [dateEntryExit, setDateEntryExit] = useState(null);
  const [timeEntry, setTimeEntry] = useState(null);
  const [timeExit, setTimeExit] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [modal, setModal] = useState(false);
  const [orgLists, setOrgLists] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [successAdd, setSuccessAdd] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [isValidate, setIsValidate] = useState(false);
  const userToken = GetCookieToken("userToken");


  useEffect(() => {
    let thisEffect = async () => {
      const orgInner = await FetchAxiosGet('/api/orgInner/level', userToken);
      let options = [{ value: '0', label: 'ทั้งหมด', parent_id: '0' }];
      await orgInner?.result?.child.map(async x => {
        if (x.active === 1) options.push({ value: x.org_id, label: x.org_name, parent_id: x.parent_id })
        x.child && x.child.map(y => {
          if (x.active === 1) options.push({ value: y.org_id, label: y.org_name, parent_id: y.parent_id })
          y.child && x.child.map(z => {
            if (x.active === 1) options.push({ value: z.org_id, label: z.org_name, parent_id: z.parent_id })
          })
        })
      })
      options = options.filter((obj, index, self) => {
        return index === self.findIndex((t) => (
          t.value === obj.value
        ));
      });
      setOrgOptions(options)
    }
    thisEffect();
    orgOptions && setLoading(false);
  }, []);

  const orgChange = async (value) => {
    setSuccessAdd(false);
    let orgParent = value, org = value;
    let orgList = await orgOptions.filter(x => parseInt(x?.parent_id) === parseInt(orgParent) || parseInt(x?.value) === parseInt(org))
    if (parseInt(orgParent) === 0) {
      orgList = await orgOptions.filter(x => parseInt(x?.value) !== 0)
    }
    await setOrgLists(orgList);
  }

  const saveTimeEntryExit = async () => {
    try {
      setDisabled(true);
      let baseURL = API_URL + `/api/time/entryExitOrg`;
      const config = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      let response = await axios.post(baseURL, { orgLists: orgLists, dateEntryExit: dateEntryExit, timeEntry: timeEntry, timeExit: timeExit || new Date() 
        }, config);
      if (response) {
        setModal(false);
        // setDateEntryExit('');
        // setTimeEntry('');
        // setTimeExit('');
      }
      setDisabled(false);
      setSuccessAdd(true);
    } catch (error) {
      setDisabled(false);
    }
  }

  const [checkStr,setCheckStr] = useState({
    date : null,
    timeEn : null
  })

  const setDateInObj = (e) => {
    setCheckStr(prevState => ({
      ...prevState,
      date : e
    }));
  }

  const setTimeEnInObj = (e) => {
    setCheckStr(prevState => ({
      ...prevState,
      timeEn : e
    }));
  }

  useEffect(() => {
    checkStr?.date && checkStr?.timeEn && setIsValidate(true)
  }, [checkStr])

  useEffect(() => {
    if (userInfo) {
      if (
        !CheckPosition(userInfo?.position) &&
        !CheckSubAdmin(userInfo?.positionSubAdmin)
      ) 
      {
        navigate("/setdata");
      }
    }
  }, [userInfo]);

  return (
    <Fragment>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <LoadingPage />
        </div>
      ) : (
        <FadeIn>
          <Modal backdrop={'static'} isOpen={modal} toggle={() => { setModal(false) }} size="sm" centered={true}>
            <ModalHeader toggle={() => { setModal(false) }}>
              ต้องการลงเวลาเข้าออกงานใช่หรือไม่ ?
            </ModalHeader>
            <ModalFooter>
              <Button color="success" onClick={
                saveTimeEntryExit
                } disabled={disabled}>
                {disabled ? <i class="fa-solid fa-floppy-disk pe-2 fa-fade"></i> : <i class="fa-solid fa-floppy-disk pe-2"></i>}บันทึก
              </Button>{' '}
              <Button color="danger" onClick={() => { setModal(false) }} disabled={disabled}>
                <i class="fa-solid fa-xmark pe-2"></i>ยกเลิก
              </Button>
            </ModalFooter>
          </Modal>
          <Card style={{ minHeight: '300px' }}>
            <CardBody>
              <Nav tabs className="mb-3">
                <NavItem>
                  <NavLink
                    className={activeTab === 1 && 'active'}
                    onClick={() => { setActiveTab(1) }}
                  >
                    <i class="fa-solid fa-user pe-2"></i>แบบบุคคล
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === 2 && 'active'}
                    onClick={() => { setActiveTab(2) }}
                  >
                    <i class="fa-duotone fa-user-group pe-2"></i>แบบกลุ่ม
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={`${activeTab}`}>
                <TabPane tabId="1">
                  <PersonalTimeEntryExitGroup />
                </TabPane>
                <TabPane tabId="2">
                  <Toast className="align-items-center text-white bg-success border-0 mb-2 shadow-none"
                    isOpen={successAdd} role="alert" aria-label="assertive" aria-atomic={true} >
                    <ToastBody className="d-flex">
                      <i class="fa-solid fa-circle-check m-0 mt-1 me-2"></i>
                        บันทึกสำเร็จ
                      <button onClick={() => setSuccessAdd(false)} type="button" class="btn-close btn-close-white me-0 m-auto" />
                    </ToastBody>
                  </Toast>
                  <Form
                    className={submit ? 'was-validated' : ''}
                    noValidate
                    onSubmit={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSubmit(true);
                      if (orgLists.length > 0 && dateEntryExit && timeEntry) {
                        setModal(true);
                      }
                    }}
                  >
                    <Row>
                      <Col lg={12}>
                        <FormGroup>
                          <Label className="text-danger">* สำนัก/กอง/กลุ่ม</Label>
                          {orgOptions ? <Select
                            className="basic-single"
                            classNamePrefix="สำนัก/กอง"
                            defaultValue='0'
                            isSearchable={true}
                            placeholder='สำนัก/กอง...'
                            options={orgOptions}
                            required={true}
                            onChange={async e => orgChange(e?.value)}
                          /> : <h5><i class="fa-duotone fa-spinner-third fa-spin"></i></h5>}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <FormGroup>
                          <Label>ลงเวลาเข้าออกงาน</Label>
                          <Table hover bordered responsive>
                            <thead className="table-light table-nowrap">
                              <tr>
                                <th className="p-2 py-1 text-nowrap text-danger W-25">* วันที่</th>
                                <th className="p-2 py-1 text-nowrap text-danger W-25">* เวลาเข้างาน</th>
                                <th className="p-2 py-1 text-nowrap W-25">เวลาออกงาน</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  {/* <Input name="dateEntryExit" id="dateEntryExit" value={dateEntryExit} type="date" placeholder="เลือกวันที่ ..." required={true}
                                    onChange={(e) => { setDateEntryExit(e?.target.value) }}
                                  /> */}
                                  <NewThaiDatePicker name ={"dateEntryExit"} value={dateEntryExit} setValue={setDateEntryExit} invalidProps={!dateEntryExit} requireProps={!dateEntryExit} placeholderText = "วัน/เดือน/ปี"/>
                                </td>
                                <td>
                                  <Input name="timeEntry" id="timeEntry" type="time" step="1" value={timeEntry} placeholder="เลือกวันที่ ..." required={true}
                                    onChange={(e) => { setTimeEntry(e?.target.value) }}
                                  />
                                </td>
                                <td >
                                  <Input name="timeExit" id="timeExit" type="time" step="1" value={timeExit} placeholder="เลือกวันที่ ..."
                                    onChange={(e) => { setTimeExit(e?.target.value) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={11}></Col>
                      <Col lg={1} className="text-end">
                        <Button className="text-nowrap" color="success" type="submit">
                          <i class="fa-solid fa-floppy-disk pe-2"></i>บันทึก
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </FadeIn>
      )}
    </Fragment>
  );
}

export default TimeEntryExitGroup;
